/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const DownloadIcon = /*#__PURE__*/ createSvgIcon(
  'DownloadIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M9.996 12.688a.756.756 0 01-.281-.053.691.691 0 01-.236-.156L6.521 9.521a.688.688 0 01-.219-.53.788.788 0 01.77-.762.73.73 0 01.532.23l1.646 1.666V3.75c0-.212.071-.39.214-.534A.72.72 0 019.996 3c.21 0 .39.072.535.216a.72.72 0 01.219.534v6.375l1.667-1.667a.676.676 0 01.527-.218.808.808 0 01.545.24.745.745 0 01-.01 1.062l-2.958 2.937a.756.756 0 01-.525.208zM5.494 16c-.413 0-.765-.147-1.056-.44A1.45 1.45 0 014 14.5v-.75c0-.213.071-.39.214-.534A.72.72 0 014.746 13c.21 0 .39.072.535.216a.72.72 0 01.219.534v.75h9v-.75c0-.213.072-.39.214-.534a.72.72 0 01.532-.216c.21 0 .39.072.535.216a.72.72 0 01.219.534v.75c0 .412-.147.766-.44 1.06-.295.293-.648.44-1.06.44H5.493z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default DownloadIcon;
